import axios from "../../../axios-defaults";

let getDipReadingDevices = async (tankCodes) => {
	return await axios.get("/tanks/getDipReadingDevices", {
		params: { tankNumberList: tankCodes, }
	}).then(response => {
		if (response.data.succeeded) return response.data.data;
		else return [];
	}).catch(error => {
		return [];
	});
}

export default getDipReadingDevices;
